<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">THÔNG TIN ĐƠN HÀNG #{{ data ? data.id : 'x' }}</h4>
			<!-- <h4 v-else class="uppercase font-bold block text-xl w-full">LỆNH MUA NGAY</h4>
			<p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings" v-if="data && data.id">
			
			<div data-v-612d160a="" data-v-63a637f4="" class="request-steps -mx-6">
				<div data-v-612d160a="" class="ps">
					<ul data-v-612d160a="" class="steps-container">
						
						<li data-v-612d160a="" class="step-item step-item--active" :key="indextr" v-for="(status, indextr) in statusForDetail"
							:class="'status_'+status.id" style="--custom-color: white;;" :style="{'z-index': (50 - indextr), '--custom-bg-color': status.color, opacity: (status.id <= (data && currentStatus  ? currentStatus : 0) ? 1 : 0.2)}"><span
								data-v-612d160a="" class="step-item__name">{{ status.name }}</span></li>
					</ul>
					<div class="ps__rail-x" style="left: 0px; bottom: 0px;">
						<div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
					</div>
					<div class="ps__rail-y" style="top: 0px; right: 0px;">
						<div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
					</div>
				</div>
			</div>

			<div class="px-6" v-if="isPopupActiveLocal">
				
				<div class="flex justify-between items-baseline "><span class="text-black mb-5 content-heading">Thông tin</span><!----></div>
				
				<fieldset class="fieldset-custom mb-5">
					<legend>Thông tin đơn hàng</legend>
					<vs-row class="mb-5">
						<vs-col vs-w="7" style="display: flex; vertical-align: middle;">
							<div class="w-full">
								<label for class="text-base vs-input--label">
									Người mua
								</label>
								<cbs-input type="text" v-model="nguoi_mua" class="w-full" readOnly/>
							</div>
						</vs-col>
						<vs-col vs-w="5" style="display: flex; vertical-align: middle;">
							<div class="w-full pl-2">
								<label for class="text-base vs-input--label">
									Ngày muốn nhận:
								</label>
								<CbsDatePicker :disabled="true" value-format="yyyy-MM-dd HH:mm" name="expected_date" class="w-full" v-model="expected_date" type="datetime" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
							</div>
						</vs-col>
					</vs-row>
					<vs-row :key="indexLoaica" v-for="(detail, indexLoaica) in details">
						<vs-col vs-lg="4" vs-sm="4" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full">
								<label for class="text-base vs-input--label">
									{{ detail.product ? detail.product.name : '' }}
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									:value="detail.quantity"
									readOnly
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="3" vs-sm="3" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pl-2">
								<label for class="text-base vs-input--label">
									Đơn giá
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									:value="detail.price"
									readOnly
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="5" vs-sm="5" style="display: flex; vertical-align: middle;" class="mb-5">
							<div class="w-full pl-2">
								<label for class="text-base vs-input--label">
									Thành tiền
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									:value="detail.quantity * detail.price"
									readOnly
								/>
							</div>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5">
						<vs-col vs-lg="7" vs-sm="7" style="display: flex; vertical-align: middle;">
							<div class="w-full">
								<label for class="text-base vs-input--label">
									Tổng lượng (kg)
									<span class="text-danger">*</span>:
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									v-model.number="total_quantity"
									readOnly
								/>
							</div>
						</vs-col>
						<vs-col vs-lg="5" vs-sm="5" style="display: flex; vertical-align: middle;">
							<div class="w-full pl-2">
								<label for class="text-base vs-input--label">
									Tổng tiền (vnd):
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									:value="total"
									readOnly
								/>
							</div>
						</vs-col>
					</vs-row>

					<vs-row class="mb-5" v-if="history_note != null">
						<vs-col vs-w="12" style="display: flex; vertical-align: middle;" :set="histories = getHistoryAsArray()">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Lịch sử:
								</label>
								<vs-row class="mb-1" :key="indextr" v-for="(history, indextr) in histories">
									<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
										<label class="text-base vs-input--label">
											{{ history }}
										</label>
									</vs-col>
								</vs-row>
							</div>
						</vs-col>
					</vs-row>
				</fieldset>


				<!-- thong tin duyet mua -->
				<fieldset class="fieldset-custom mb-5" v-if="status != 1 && status != 3">
					<legend>Thông tin duyệt mua</legend>
					<vs-row class="mb-5">
						<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
							<vs-checkbox name="is_shipping" v-model="is_shipping" color="primary" id="is_shipping" readOnly disabled="true" />
							<label for="is_shipping" class="text-base vs-input--label">
								Đơn này yêu cầu vận chuyển
							</label>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5">
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Số ghe
									<span class="text-danger">*</span>:
								</label>
								<cbs-input type="text" v-model="vehicle_no" class="w-full" name="vehicle_no" v-validate="'required'" />
							</div>
						</vs-col>
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Ngày dự kiến xuất
									<span class="text-danger">*</span>:
								</label>
								<CbsDatePicker value-format="yyyy-MM-dd HH:mm" name="sell_date" class="w-full" v-model="sell_date" type="datetime" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
							</div>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5">
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Tài xế
									<span class="text-danger">*</span>:
								</label>
								<cbs-input type="text" v-model="driver_name" class="w-full" name="driver_name" v-validate="'required'" />
							</div>
						</vs-col>
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Điện thoại
									<span class="text-danger">*</span>:
								</label>
								<cbs-input type="text" v-model="driver_phone" class="w-full" name="driver_phone" v-validate="'required'" />
							</div>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5">
						<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Ghi chú:
								</label>
								<vs-textarea type="text" v-model="accepted_note" class="w-full" name="accepted_note" />
							</div>
						</vs-col>
					</vs-row>
				</fieldset>


				<!-- thong tin thanh toan -->
				<fieldset class="fieldset-custom mb-5" v-if="payment_date != null">
					<legend>Thông tin thanh toán</legend>
					<vs-row class="mb-5">
						<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
							<vs-checkbox name="is_dept" v-model="is_dept" color="primary" id="is_dept" readOnly disabled="true" />
							<label for="is_dept" class="text-base vs-input--label">
								Đơn công nợ (khách hàng chọn nợ đơn trên app)
							</label>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5">
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Ngày thanh toán:
								</label>
								<CbsDatePicker :disabled="true" value-format="yyyy-MM-dd HH:mm" name="payment_date" class="w-full" v-model="payment_date" type="datetime" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
							</div>
						</vs-col>
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								
							</div>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5">
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Số tiền đã thanh:
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									v-model="payment_value"
									readOnly
								/>
							</div>
						</vs-col>
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Còn nợ:
								</label>
								<CbsMaskedInput
									dataType="int"
									class="vs-inputx vs-input--input normal"
									:userSetting="{}"
									:value="total - payment_value"
									readOnly
								/>
							</div>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5" v-if="files && files.length">
						<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Ảnh chuyển tiền:
								</label>
								
								<CbsUploadRefCustom
									value="value"
									v-model="localAttachFile"
									accept="image/*"
									:limit="10"
									:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
									:dataValue="files"
									:isEditable="0"
								/>
							</div>
						</vs-col>
					</vs-row>
				</fieldset>

				<!-- thong tin xuat hang -->
				<fieldset class="fieldset-custom mb-5" v-if="tested_date != null">
					<legend>Thông tin xuất hàng</legend>
					<vs-row class="mb-5">
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Thời gian hoàn thành:
								</label>
								<CbsDatePicker :disabled="true" value-format="yyyy-MM-dd HH:mm" name="tested_date" class="w-full" v-model="tested_date" type="datetime" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
							</div>
						</vs-col>
						<vs-col vs-w="6" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									KCS thông tin
								</label>
								<cbs-input type="text" v-model="tester_name" class="w-full" readOnly/>
							</div>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5" v-if="isKcsDanhGia()">
						<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									KCS đánh giá:
								</label>
								<vs-row class="mb-1" :key="indextr" v-for="(kcsOption, indextr) in kcsListOpts">
									<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
										<label :for="'kcs_option'+kcsOption.id" class="text-base vs-input--label">
											- {{ !kcsOptions[kcsOption.id] ? 'Không ' : '' }} {{ kcsOption.name }}
										</label>
									</vs-col>
								</vs-row>
							</div>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5" v-if="tested_note != null">
						<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Ghi chú KCS:
								</label>
								<p>
									{{ tested_note }}
								</p>
								<!-- <vs-textarea type="text" v-model="tested_note" class="w-full" name="tested_note" readOnly /> -->
							</div>
						</vs-col>
					</vs-row>
					<vs-row class="mb-5">
						<vs-col vs-w="12" style="display: flex; vertical-align: middle;">
							<div class="w-full pr-2">
								<label for class="text-base vs-input--label">
									Ảnh KCS gửi:
								</label>
								
								<CbsUploadRefCustom
									value="value"
									v-model="localAttachFile"
									accept="image/*"
									:limit="10"
									:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
									:dataValue="kcs_files"
									:isEditable="0"
								/>
							</div>
						</vs-col>
					</vs-row>
				</fieldset>
			</div>
		</PerfectScrollbar>

		<div slot="footer" style="padding: 0;" v-if="data && data.id">
			<div v-if="expected_date_changed" style="position: relative;">
				<span class="text-warning text-sm break-normal custom-text-change-date" style="display: block;">(*) Khách hàng muốn đổi ngày xuất hàng sang <label style="color: black;">{{ $helper.momentFormat(expected_date, 'DD/MM/YYYY HH:mm') }}</label></span>
				<div class="p-4">
					<vs-button class="w-full sm:w-1/3 font-bold mr-2" color="danger" type="filled" @click.stop="submitData(currentStatus, 0)" >Từ chối</vs-button>
					<vs-button class="w-full sm:w-1/3 font-bold ml-2" @click.stop="submitData(currentStatus, 1)" >Đồng ý</vs-button>
				</div>
			</div>
			<div class="p-4 flex justify-center" style="display: flex; vertical-align: middle;" v-if="!expected_date_changed">
				<vs-button v-if="currentStatus == 0" class="w-full sm:w-1/3 font-bold mr-2" color="danger" type="filled" @click.stop="submitData(1)" >Từ chối</vs-button>
				<vs-button v-if="currentStatus == 0" class="w-full sm:w-1/3 font-bold ml-2" @click.stop="submitData(2)" >Duyệt mua</vs-button>


				<vs-button v-if="currentStatus == 5" class="w-full sm:w-1/3 font-bold mr-2" color="danger" type="filled" @click.stop="submitData(8)" >Từ chối thanh toán</vs-button>
				<vs-button v-if="currentStatus == 5" class="w-full sm:w-1/3 font-bold ml-2" @click.stop="submitData(6)" >Xác nhận thanh toán</vs-button>

				<vs-button v-if="currentStatus == 6" class="w-full sm:w-1/3 font-bold ml-2" @click.stop="submitData(6)" >Đổi thông tin xuất hàng</vs-button>


				<vs-button v-if="currentStatus != 0 && currentStatus != 5 && currentStatus != 6" class="w-full sm:w-1/3 font-bold ml-2" @click.stop="closeThisModal()" >Đóng lại</vs-button>
			</div>
		</div>
		
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import CbsMaskedInput from "@/components/cbs-masked-input/CbsMaskedInput";
import CbsUploadRefCustom from "@/components/cbs-upload-ref/CbsUploadRefCustom";

let shippingOptions = {};

export default {
	name: "OrderFormTa",
	components: { vSelect, SelectAssigned, CbsUploadRef, CbsMaskedInput, CbsUploadRefCustom },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			total: 0,
			total_quantity: 0,
			details: [],
			currentStatus: 0,
			history_note: null,
			is_dept: false,
			kcsListOpts: [
				{id: 'dat_chat_luong_bao_bi', name: 'Đạt chất lượng bao bì'},
				{id: 'dat_toc_do_xuat_hang', name: 'Đạt tốc độ xuất hàng'},
				{id: 'dat_tinh_can_than', name: 'Đạt tính cẩn thận'},
				{id: 'dam_bao_an_toan_lao_dong', name: 'Đảm bảo an toàn lao động'},
			],
			kcsOptions: {},
			statusForDetail: [
				{id: 0, name: 'Tạo đơn', color: '#AF00CC'},
				{id: 2, name: 'Duyệt mua', color: '#63BA46'},
				{id: 4, name: 'Chờ TT', color: '#0E9F96'},
				{id: 5, name: 'Duyệt TT', color: '#057FBB'},
				{id: 6, name: 'Chờ xuất', color: '#D2AC24'},
				{id: 7, name: 'Hoàn thành', color: '#1DD100'},
			],
			is_shipping: true,
			pickerOptions: {
				disabledDate (time) {
					// return date < new Date()
					const date = new Date();
					const previousDate = date.setDate(date.getDate() - 1);
					return time.getTime() < previousDate; 
				},
				'defaultTime': '08:00:00'
			},
			require_qc: 0,
			provinces: [],
			districts: [],
			placeData: [],
			priceMaps: {},
			customErrors: null,
			timeKey: Date.now(),
			files: [],
			value: {},
			product: null,
			supplier: null,
			quantity: null,
			price: null,
			address: null,
			cus_note: null,
			canSelectSupplier: false,
			canBuy: false,
			canSell: false,

			'supplier_name': null,
            'supper_phone': null,
            'supper_mst': null,
            'supplier_bankaccount': null,
            'supplier_bankname': null,
            'supplier_bankowner': null,
			shipping_method: 1,

			id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			province: null,
			district: null,
			prevent_slit: 0,
			orderNow: 0,
			data2: {},

			nguoi_mua: null,
			mat_hang: null,
			expected_date: null,
			sell_date: null,
			driver_name : null,
			driver_phone: null,
			vehicle_no: null,
			payment_date: null,
			payment_value: 0,
			tested_date: null,
			tester_name: null,
			kcs_files: [],
			accepted_note: null,
			status: 0,
			expected_date_changed: 0,
			tested_note: null,
			isFormDirty: false,
		};
	},
	watch: {
		province(val) {
			console.log('province: ', val);
			this.getDistricts();
		},
		isPopupActive(val) {
			if (!val) return;
			if (!this.data || !this.data.id) {
				return;
			}
			this.currentStatus = this.data.status || 0;
			if (!this.data.hasOwnProperty('need_update')) {
				this.fetchData(this.data);
			} else {
				this.getOrder();
			}
			return;

			const { expected_date_changed, history_note, status, is_dept, expected_date, sell_date, product, creater, is_shipping, driver_name, driver_phone, vehicle_no, payment_date, payment_value, accepted_note, so,
				 supplier, quantity, price, cus_note, address, photos = [], id = 0, supplier_name, supper_phone, supper_mst, supplier_bankaccount, supplier_bankname, supplier_bankowner, shipping_method,
				shipping_options, type, state_id, district_id, prevent_slit, orderNow = 0, require_qc = 0
			} = this.data;
			this.expected_date = expected_date;
			this.sell_date = sell_date;
			this.is_shipping = is_shipping;
			this.driver_name = driver_name;
			this.driver_phone = driver_phone;
			this.vehicle_no = vehicle_no;
			this.payment_value = payment_value;
			this.payment_date = payment_date ? this.$helper.momentFormatLocale(payment_date, 'YYYY-MM-DD HH:mm:ss') : null;
			this.accepted_note = accepted_note;
			this.is_dept = is_dept;
			this.status = status;
			this.history_note = history_note;
			this.expected_date_changed = expected_date_changed;

			if (so) {
				let {buyer_payments, tested_date, tester, kcs_photos, kcs_options, tested_note} = so;
				if (buyer_payments) {
					this.files = buyer_payments;
				} else {
					this.files = [];
				}
				this.tested_date = tested_date ? this.$helper.momentFormatLocale(tested_date, 'YYYY-MM-DD HH:mm:ss') : null;
				this.tester_name = tester ? tester.name : null;
				this.kcs_files = kcs_photos ? kcs_photos : [];
				if (kcs_options && Object.keys(kcs_options).length) {
					this.kcsOptions = kcs_options;
				} else {
					this.kcsOptions = {};
				}
				this.tested_note = tested_note;
			} else {
				this.tested_date = null;
				this.tester_name = null;
				this.kcs_files = [];
				this.files = [];
				this.kcsOptions = {};
				this.tested_note = null;
			}

			this.orderNow = orderNow;
			if (product) {
				this.product = product.id;
				this.mat_hang = product.name;
			} else {
				this.product = null;
			}
			this.nguoi_mua = creater.name || null;
			if (supplier) {
				this.supplier = supplier.id;
			} else {
				this.supplier = null;
			}
			
			if (quantity) {
				this.quantity = quantity;
			} else {
				this.quantity = null;
			}
			if (shipping_options) {
				shippingOptions = shipping_options;
			}
			 else {
				shippingOptions = {};
			}
			if (price) {
				this.price = price;
			} else {
				this.price = null;
			}
			if (supplier_name) {
				this.supplier_name = supplier_name;
			} else {
				this.supplier_name = null;
			}
			if (supper_phone) {
				this.supper_phone = supper_phone;
			} else {
				this.supper_phone = null;
			}
			if (supper_mst) {
				this.supper_mst = supper_mst;
			} else {
				this.supper_mst = null;
			}
			if (supplier_bankaccount) {
				this.supplier_bankaccount = supplier_bankaccount;
			} else {
				this.supplier_bankaccount = null;
			}
			if (supplier_bankname) {
				this.supplier_bankname = supplier_bankname;
			} else {
				this.supplier_bankname = null;
			}
			if (supplier_bankowner) {
				this.supplier_bankowner = supplier_bankowner;
			} else {
				this.supplier_bankowner = null;
			}
			if (address) {
				this.address = address;
			} else {
				this.address = null;
			}
			if (cus_note) {
				this.cus_note = cus_note;
			} else {
				this.cus_note = null;
			}
			if (photos) {
				this.photos = photos;
			} else {
				this.photos = null;
			}
			if (id) {
				this.id = id;
				this.getOrder();
			} else {
				this.id = null;
			}
			if (shipping_method) {
				this.shipping_method = shipping_method;
			}
			if (state_id) {
				this.province = state_id;
			} else {
				this.province = null;
			}
			if (district_id) {
				this.district = district_id;
			} else {
				this.district = null;
			}
			if (prevent_slit) {
				this.prevent_slit = 1;
			} else {
				this.prevent_slit = 0;
			}
			if (require_qc) {
				this.require_qc = 1;
			} else {
				this.require_qc = 0;
			}

			this.isFormDirty = false;
			this.initFormData = {};
			if (status == 3) {
				this.statusForDetail[1] = {id: status, name: 'Đã hủy', color: '#FF6262'};
				
			} else if (status == 1) {
				this.statusForDetail[1] = {id: status, name: 'Từ chối', color: '#FF6262'};
				
			} else if (status == 8) {
				this.statusForDetail[3] = {id: status, name: 'Từ chối', color: '#FF6262'};
				this.statusForDetail[4] = {id: 66, name: 'Chờ xuất', color: '#D2AC24'};
				this.statusForDetail[5] = {id: 77, name: 'Hoàn thành', color: '#1DD100'};
			} else {
				this.statusForDetail[1] = {id: 2, name: 'Duyệt mua', color: '#63BA46'};
			}
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
		city() {
			if (this.city) {
				this.$store.dispatch("getDistrict", {
					provinceCode: this.city,
				});
			}
		},
		district() {
			if (this.district) {
				this.$store.dispatch("getWard", {
					districtCode: this.district,
				});
			}
		},
	},
	computed: {
		localAttachFile: {
			get() {
				// console.log('this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				// console.log('set.value: ' , val);
				// console.log(typeof val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				if (this.files.length) {
					this.customErrors = null;
				}
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		computedFormData() {
			return {
				id: this.id,
				fullName: this.fullName,
				nickname: this.nickname,
				phone: this.phone,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				assigned: this.assigned,
				totalPool: this.totalPool,
			};
		},
	},
	created() {
		
	},
	methods: {
		fetchData(tempData) {
			const {total, total_quantity, details, expected_date_changed, history_note, status, is_dept, expected_date, sell_date, product, creater, is_shipping, driver_name, driver_phone, vehicle_no, payment_date, payment_value, accepted_note, so,
				 supplier, quantity, price, cus_note, address, photos = [], id = 0, supplier_name, supper_phone, supper_mst, supplier_bankaccount, supplier_bankname, supplier_bankowner, shipping_method,
				shipping_options, type, state_id, district_id, prevent_slit, orderNow = 0, require_qc = 0
			} = tempData;
			this.expected_date = expected_date;
			this.sell_date = sell_date;
			this.is_shipping = is_shipping;
			this.driver_name = driver_name;
			this.driver_phone = driver_phone;
			this.vehicle_no = vehicle_no;
			this.payment_value = payment_value;
			this.payment_date = payment_date ? this.$helper.momentFormatLocale(payment_date, 'YYYY-MM-DD HH:mm:ss') : null;
			this.accepted_note = accepted_note;
			this.is_dept = is_dept;
			this.status = status;
			this.currentStatus = status;
			this.history_note = history_note;
			this.expected_date_changed = expected_date_changed;
			this.details = details;
			this.total = total;
			this.total_quantity = total_quantity;

			if (so) {
				let {buyer_payments, tested_date, tester, kcs_photos, kcs_options, tested_note} = so;
				if (buyer_payments) {
					this.files = buyer_payments;
				} else {
					this.files = [];
				}
				this.tested_date = tested_date ? this.$helper.momentFormatLocale(tested_date, 'YYYY-MM-DD HH:mm:ss') : null;
				this.tester_name = tester ? tester.name : null;
				this.kcs_files = kcs_photos ? kcs_photos : [];
				if (kcs_options && Object.keys(kcs_options).length) {
					this.kcsOptions = kcs_options;
				} else {
					this.kcsOptions = {};
				}
				this.tested_note = tested_note;
			} else {
				this.tested_date = null;
				this.tester_name = null;
				this.kcs_files = [];
				this.files = [];
				this.kcsOptions = {};
				this.tested_note = null;
			}

			this.orderNow = orderNow;
			if (product) {
				this.product = product.id;
				this.mat_hang = product.name;
			} else {
				this.product = null;
			}
			this.nguoi_mua = creater ? creater.name : null;
			if (supplier) {
				this.supplier = supplier.id;
			} else {
				this.supplier = null;
			}
			
			if (quantity) {
				this.quantity = quantity;
			} else {
				this.quantity = null;
			}
			if (shipping_options) {
				shippingOptions = shipping_options;
			}
			 else {
				shippingOptions = {};
			}
			if (price) {
				this.price = price;
			} else {
				this.price = null;
			}
			if (photos) {
				this.photos = photos;
			} else {
				this.photos = null;
			}
			if (id) {
				this.id = id;
				// this.getOrder();
			} else {
				this.id = null;
			}

			this.isFormDirty = false;
			this.initFormData = {};
			if (status == 3) {
				this.statusForDetail[1] = {id: status, name: 'Đã hủy', color: '#FF6262'};
				
			} else if (status == 1) {
				this.statusForDetail[1] = {id: status, name: 'Từ chối', color: '#FF6262'};
				
			} else if (status == 8) {
				this.statusForDetail[3] = {id: status, name: 'Từ chối', color: '#FF6262'};
				this.statusForDetail[4] = {id: 66, name: 'Chờ xuất', color: '#D2AC24'};
				this.statusForDetail[5] = {id: 77, name: 'Hoàn thành', color: '#1DD100'};
			} else {
				this.statusForDetail[1] = {id: 2, name: 'Duyệt mua', color: '#63BA46'};
			}
		},
		getHistoryAsArray() {
			if (this.history_note) {
				let separateLines = this.history_note.split(/\r?\n|\r|\n/g);
				return separateLines;
			}
			return [];
		},
		isKcsDanhGia() {
			let ok = false;
			Object.keys(this.kcsOptions).forEach(key => {
				if (this.kcsOptions[key]) {
					ok = true;
					return ok;
				}
			})
			return ok;
		},
		closeThisModal() {
			this.$emit("closePopup");
		},
		async getOrder() {
			console.log('getOrder');
			if (this.data && this.data.id) {
				this.$vs.loading();
				try {
					await this.$store.dispatch("moduleProduct/getPoById", this.data.id).then(response => {
						console.log('getOrder response: ', response);
						this.fetchData(response);
					});
					this.$vs.loading.close();
				} catch (error) {
					this.$vs.loading.close();
				}
			}
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.orderNow = 0;
			// this.shipping_method = "1";
			// this.priceMaps = {};
			this.$validator.reset();
		},
		submitData(status, isAcceptChangedDate = null) {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: this.$t("Actions.Confirm"),
				text: 'Bạn có chắc thực hiện việc này',
				accept: () => {
					const dataObj = {
						isPo: 1,
						status: status,
						id: this.data.id,
						driver_name: this.driver_name,
						driver_phone: this.driver_phone,
						vehicle_no: this.vehicle_no,
						sell_date: this.sell_date,
						accepted_note: this.accepted_note,
						isAcceptChangedDate: isAcceptChangedDate
					};
					this.handleCreateOrUpdate(dataObj);
					// this.$validator.validateAll().then((result) => {
					// 	if (result) {
					// 		const dataObj = {
					// 			isPo: 1,
					// 			status: status,
					// 			id: this.data.id,
					// 		};

					// 		this.handleCreateOrUpdate(dataObj);
					// 	}
					// });
				},
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		handleCreateOrUpdateSuccess() {
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Cập nhật thành công",
				},
			});
			this.$emit("closePopup");
			// if (this.orderNow) {
			// 	setTimeout(() => {
			// 		this.$router.push('/cac-lenh-ban');
			// 	}, 1000);
			// }
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/createOrder", dataObj).then(response => {
					console.log('response: ', response);
					this.handleCreateOrUpdateSuccess(response);
				});
				// this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>

<style>
/* .el-time-spinner .el-time-spinner__wrapper:nth-child(1) .el-time-spinner__item:nth-child(1),
.el-time-spinner .el-time-spinner__wrapper:nth-child(1) .el-time-spinner__item:nth-child(2),
.el-time-spinner .el-time-spinner__wrapper:nth-child(1) .el-time-spinner__item:nth-child(3),
.el-time-spinner .el-time-spinner__wrapper:nth-child(1) .el-time-spinner__item:nth-child(4),
.el-time-spinner .el-time-spinner__wrapper:nth-child(1) .el-time-spinner__item:nth-child(5)
{
	background-color: #F5F7FA;
	cursor: not-allowed;
	opacity: 1;
	color: #C0C4CC;
	pointer-events: none;
} */
.custom-dialog .el-dialog .el-dialog__footer {
	padding: 0 !important;
}
.custom-text-change-date {
	display: block;
    position: absolute;
    top: -15px;
    left: 0;
    right: 0;
    background: white;
}
.cbs-upload__uploader--readonly .el-upload {
	display: none;
}
/* .status_0:after {
	border-left-color: #AF00CC !important;
}
.status_2:after {
	border-left-color: #63BA46 !important;
}
.status_4:after {
	border-left-color: #0E9F96 !important;
}
.status_5:after {
	border-left-color: #057FBB !important;
}
.status_6:after {
	border-left-color: #D2AC24 !important;
}
.status_7:after {
	border-left-color: #1DD100 !important;
} */
.content-heading {
    font-weight: 700;
    font-size: 16px;
    color: var(--color-black);
    text-transform: uppercase;
}
.el-dialog__body {
	height: calc(100% - 130px) !important;
	overflow: auto;
}
 .fieldset-custom {
	padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.2);
 }
 .vs-checkbox--check {
	/*
	-webkit-transform: translate(0%) !important;
	transform: translate(0%) !important;
	*/
	display: none;
 }
 .vs-checkbox--input:checked+.vs-checkbox .vs-checkbox--check {
	display: block;
 }


 .request-steps .steps-container[data-v-612d160a] {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    list-style: none
}

.request-steps .steps-container .step-item-blink[data-v-612d160a] {
    -webkit-animation: fadeIn-data-v-612d160a 1s infinite alternate;
    animation: fadeIn-data-v-612d160a 1s infinite alternate
}

.request-steps .steps-container .step-item-short[data-v-612d160a] {
    height: 28px!important;
    width: 56px!important;
    padding: 0 0 0 5px!important;
    color: #fff;
    font-weight: 700
}

.request-steps .steps-container .step-item-short[data-v-612d160a]:after,.request-steps .steps-container .step-item-short[data-v-612d160a]:before {
    content: "";
    border-top: 14px solid transparent!important;
    border-bottom: 14px solid transparent!important
}

.request-steps .steps-container .step-item[data-v-612d160a] {
    font-weight: 700;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 56px;
    position: relative;
    margin-left: 5px;
    padding: 0 0 0 10px;
    background-color: var(--custom-bg-color);
    opacity: .5;
    -webkit-transition: var(--common-transition);
    transition: var(--common-transition);
    cursor: pointer;
    border-left-color: var(--custom-bg-color)
}

.request-steps .steps-container .step-item[data-v-612d160a]:after,.request-steps .steps-container .step-item[data-v-612d160a]:before {
    content: "";
    border-left: 10px solid #fff;
    border-top: 28px solid transparent;
    border-bottom: 28px solid transparent;
    position: absolute;
    top: 0
}

.request-steps .steps-container .step-item[data-v-612d160a]:after {
    left: 100%;
    z-index: 20;
    border-left-color: var(--custom-bg-color)
}

.request-steps .steps-container .step-item[data-v-612d160a]:before {
    left: 0;
    z-index: 10
}

.request-steps .steps-container .step-item[data-v-612d160a]:first-child {
    margin-left: 0
}

.request-steps .steps-container .step-item[data-v-612d160a]:first-child:before,.request-steps .steps-container .step-item[data-v-612d160a]:last-child:after {
    display: none
}

.request-steps .steps-container .step-item.step-item--waiting[data-v-612d160a] {
    background-color: var(--color-solid-primary)
}

.request-steps .steps-container .step-item.step-item--waiting[data-v-612d160a]:after {
    border-left-color: var(--color-solid-primary)
}

.request-steps .steps-container .step-item.step-item--rejected[data-v-612d160a] {
    background-color: var(--color-solid-red)
}

.request-steps .steps-container .step-item.step-item--rejected[data-v-612d160a]:after {
    border-left-color: var(--color-solid-red)
}

.request-steps .steps-container .step-item.step-item--completed[data-v-612d160a] {
    background-color: var(--color-solid-green-1)
}

.request-steps .steps-container .step-item.step-item--completed[data-v-612d160a]:after {
    border-left-color: var(--color-solid-green-1)
}

.request-steps .steps-container .step-item.step-item--canceled[data-v-612d160a] {
    background-color: var(--color-solid-gray-1)
}

.request-steps .steps-container .step-item.step-item--canceled[data-v-612d160a]:after {
    border-left-color: var(--color-solid-gray-1)
}

.request-steps .steps-container .step-item.step-item--active[data-v-612d160a] {
    opacity: 1
}

.request-steps .steps-container .step-item .step-item__name[data-v-612d160a] {
    color: var(--custom-color);
    word-break: break-word;
    line-height: normal;
    margin: 0 10px;
    white-space: nowrap
}

.request-steps .steps-container .step-item.step-item--canceled[data-v-612d160a],.request-steps .steps-container .step-item.step-item--completed[data-v-612d160a],.request-steps .steps-container .step-item.step-item--rejected[data-v-612d160a],.request-steps .steps-container .step-item.step-item--waiting[data-v-612d160a] {
    cursor: pointer
}

.request-steps .steps-container .step-item.step-item--canceled .step-item__name[data-v-612d160a],.request-steps .steps-container .step-item.step-item--completed .step-item__name[data-v-612d160a],.request-steps .steps-container .step-item.step-item--rejected .step-item__name[data-v-612d160a],.request-steps .steps-container .step-item.step-item--waiting .step-item__name[data-v-612d160a] {
    color: #fff
}

.request-steps .ps[data-v-612d160a] {
    padding-bottom: 15px
}

.request-steps[data-v-612d160a] .ps__rail-y {
    display: none
}
</style>